import { useEffect, useState } from "react";
import TitlePage from "../../../components/TitlePage";
import { Row, Col, Button } from "react-bootstrap";
import { ConsultaTotvsEmpresa, ConsultaTotvsEmpresaIndividual } from "../../../../backend/ConsultaTotvsEmpresa";
import ResponsiveDataTable from "../../../components/DataTable";
import LoadingSpinner from "../../../components/LoadinSpinner";

import BMSI from "../../../../lib/json/consultas/BMSI.json"
import SelectEmpresa from "../../../components/Select/Empresa";
import { ErroMsg, formatDateColumn, SucessoMsg } from "../../../contents/VariaveisGlobais";
import { useNavigate } from "react-router-dom";
import { usePopUp } from "../../../components/BootBox";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import { useSessionStorageState } from "../../../../hooks/useSessionStorageState";
import { format, startOfMonth } from "date-fns";
import InputGeral from "../../../components/InputGeral/Index";
import { handleNumeroBMSI, handleStatusBMSI, handleTipoBMSI } from "../../../components/GridCell/BMSI";
import ConsultaTotvs from "../../../../backend/ConsultaTotvs";

function ListaBMSI(){
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    // define a exibição do Loading
    var tabelasDefault  = BMSI.tabelas;
    
    const navigate = useNavigate();
    const currentDate = new Date()
    const firstDayOfMonthDate = startOfMonth(currentDate);
    
    const [carregar, setCarregar] = useState(false);
    const [data, setData]   = useState([]);
    const [empresa, setEmpresa] = useSessionStorageState("BMSIEmpresa", {value: "",text: "", });
    const [bmsi, setBMSI] = useSessionStorageState("BMSINumero",'');
    const [dateDe, setDateDe] = useSessionStorageState("BMSIDataDe", format(firstDayOfMonthDate, 'yyyy-MM-dd'));
    const [dateAte, setDateAte] = useSessionStorageState("BMSIDataAte", format(currentDate, 'yyyy-MM-dd'));

    // Colunas do grid
    const columns = [
        {
            Header: 'BMSI',
            accessor: "PZ2_ID",
            Cell: (item) => handleNumeroBMSI(item, DisparaBootBox, FechaBootBox, navigate),
        },
        {
            Header: 'Tipo',
            accessor: "PZ2_SERVIC",
            Cell: handleTipoBMSI
        },
        {
            Header: 'Emissão',
            accessor: "PZ2_DTINCL",
            Cell: formatDateColumn
        },
        {
            Header: 'Comp. Inicio',
            accessor: "PZ2_PCOINI",
            Cell: formatDateColumn
        },
        {
            Header: 'Comp. Fim',
            accessor: "PZ2_PCOFIM",
            Cell: formatDateColumn
        },
        {
            Header: 'Status',
            accessor: "STATUS",
            Cell: handleStatusBMSI
        }
    ];

    // Processa consulta do grid
    const listaBMSI = async () => {
        var consultaDefault = retornaConsultaDefault();
        let empresaFilial = empresa.value ? empresa.value.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresa.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) : ''

        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresaIndividual( consultaDefault, tabelasDefault, empresaFilial );
        
        if (retConsulta){
            setData(retConsulta.data);
        } 

        setCarregar(false);
    }

    const retornaConsultaDefault = () => {
        let consultaDefault = BMSI.consulta;
        let filtro = " AND PZ2_FILIAL = FILIAL(PZ2) "
        let camposAux = ", (SELECT COUNT(*) FROM TABELA(PZ2) PZ2AUX WHERE PZ2AUX.PZ2_FILIAL = PZ2.PZ2_FILIAL AND PZ2AUX.PZ2_ID = PZ2.PZ2_ID AND PZ2AUX.D_E_L_E_T_ <> '*' AND PZ2AUX.PZ2_STATUS = 'R' ) REPROVADO "
        camposAux += ", (SELECT COUNT(*) FROM TABELA(PZ2) PZ2AUX WHERE PZ2AUX.PZ2_FILIAL = PZ2.PZ2_FILIAL AND PZ2AUX.PZ2_ID = PZ2.PZ2_ID AND PZ2AUX.D_E_L_E_T_ <> '*' AND PZ2AUX.PZ2_STATUS = 'P' ) PENDENTE "
        camposAux += ", (SELECT COUNT(*) FROM TABELA(PZ2) PZ2AUX WHERE PZ2AUX.PZ2_FILIAL = PZ2.PZ2_FILIAL AND PZ2AUX.PZ2_ID = PZ2.PZ2_ID AND PZ2AUX.D_E_L_E_T_ <> '*' AND PZ2AUX.PZ2_STATUS = 'A' ) APROVADO "
        camposAux += ", (SELECT COUNT(*) FROM TABELA(PZ2) PZ2AUX WHERE PZ2AUX.PZ2_FILIAL = PZ2.PZ2_FILIAL AND PZ2AUX.PZ2_ID = PZ2.PZ2_ID AND PZ2AUX.D_E_L_E_T_ <> '*' AND PZ2AUX.PZ2_STATUS = 'A' AND PZ2_DTCONT <> '' ) CONTABIL "
        
        if(bmsi) {
            filtro += "AND PZ2_ID = '"+bmsi+"' ";
        }
        if(dateDe) {
            filtro += "AND PZ2_DTINCL >= '"+dateDe.replaceAll('-','')+"' ";
        }
        if(dateAte) {
            filtro += "AND PZ2_DTINCL <= '"+dateAte.replaceAll('-','')+"' ";
        }
        
        consultaDefault = consultaDefault.replace('CAMPOS', camposAux);
        consultaDefault = consultaDefault.replace('FILTRO', filtro);
        consultaDefault += "GROUP BY PZ2_FILIAL, PZ2_ID, PZ2_SERVIC, PZ2_DTINCL, PZ2_PCOINI, PZ2_PCOFIM, PZ2_CCCRED, PZ2_CONTAD, CT1.CT1_DESC01, PZ1_DESCRI, CTT.CTT_DESC01";

        return consultaDefault
    }

    useEffect( () => {
        listaBMSI()
    },[])

    const handleAlterar = (row) =>{
        const cFilial = row.original.PZ2_FILIAL.trim() || row.original.M0_CODFIL
        navigate(`./Alterar/${row.values.PZ2_ID}/${row.original.EMPRESA}${cFilial}`)
    }
    
    const handleVisualizar = (row) =>{
        const cFilial = row.original.PZ2_FILIAL.trim() || row.original.M0_CODFIL
        navigate(`./Visualizar/${row.values.PZ2_ID}/${row.original.EMPRESA}${cFilial}`)
    }
    
     const handleExcluir = async (row) => {
        const cFilial = row.original.PZ2_FILIAL.trim() || row.original.M0_CODFIL
        const idRow = row.original.EMPRESA + '' + cFilial + '|' + row.original.PZ2_ID;
        const Mensagem = `Tem certeza que deseja excluir o BMSI ${row.original.PZ2_ID}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };

    const handleExcluirConfirm = async(row) => {
        const empresaFilial = row.split('|')[0]
        
        let consultaDefault = BMSI.consulta;
        let filtro = "AND PZ2_FILIAL = FILIAL(PZ2) "
        let camposAux = ", PZ2_ITEM "
        
        filtro += "AND PZ2_ID = '"+row.split('|')[1] +"' ";
        
        consultaDefault = consultaDefault.replace('CAMPOS', camposAux);
        consultaDefault = consultaDefault.replace('FILTRO', filtro);
        
        FechaBootBox()
        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresaIndividual( consultaDefault, BMSI.tabelas, empresaFilial );
        
        if (retConsulta.data){
            var aJSONSalvar = [];
            retConsulta.data.map((item) => 
                aJSONSalvar.push({ 
                    ACAO: 'EXCLUIR',
                    ID: item.PZ2_ID,
                    ITEM: item.PZ2_ITEM,
                    PZ2_ID: item.PZ2_ID,
                    PZ2_ITEM: item.PZ2_ITEM,
                    deletado: true
                })
            )

            const cJSONSalvar = JSON.stringify(aJSONSalvar);
            
            try {
                const oRetorno = await ConsumoTOTVS_POST('BMSI', cJSONSalvar, empresaFilial)
                
                if (oRetorno.error === '00'){
                    SucessoMsg(oRetorno.description)
                }else{
                    ErroMsg(oRetorno.description)
                    return false;
                }
            } catch (error) {
                console.error('Error in handleExcluir:', error);
                // Handle the error, show an error message, or log it as needed.
            } finally {
                setCarregar(false);
                listaBMSI();
            }
        } 
    };

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="BMSI"/>
                </Col>
                <Col md='4'>
                    <SelectEmpresa
                        campoEmpresa={empresa}
                        onChangeEmpresa={setEmpresa}
                    />
                </Col>           
                <Col md="2" xs="12">
                    <InputGeral 
                        label="BMSI"
                        tipo='text'
                        max="6"
                        value={bmsi}  // Define o valor do campo com base no estado
                        onChange={(e) => setBMSI(e.target.value)}
                    />
                </Col>
                <Col md="3" xs="12">
                    <InputGeral
                        label="Emissão de"
                        tipo='date'
                        value={dateDe}
                        onChange={(e) => setDateDe(e.target.value)}
                    />
                </Col>
                <Col md="3" xs="12">
                    <InputGeral
                        label="Emissão até"
                        tipo='date'
                        value={dateAte}
                        onChange={(e) => setDateAte(e.target.value)}
                    />
                </Col>     
            </Row>
            <Row className="d-flex justify-content-end">
                <Col md="3" xs="12">
                    <Button 
                        variant="outline-primary" 
                        type="submit" 
                        onClick={listaBMSI}
                        className="w-100"
                    >
                        Buscar
                    </Button>
                </Col>
            </Row>
            
            <Row>
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons={[
                            {isVisual: true, action: handleVisualizar, label: "Visualizar", icone: "MdOutlinePreview", style: "light"}, 
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote", regraExclude: "( row.original.CONTABIL > 0 && row.original.APROVADO == row.original.CONTABIL )" }, 
                            {isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", style: "danger", regraExclude: "( row.original.CONTABIL > 0 && row.original.APROVADO == row.original.CONTABIL )" }
                        ]}
                        paginacao={100}
                    />
                </Col>
            </Row>
        </>
    );
}

export default ListaBMSI;